import { createCodebookSelector } from '@/modules/codebooks';

/**
 * Selektor typu stanice — položky číselníku z kategorie (Folder) „StationType", tj. všechny hodnoty
 * nastavitelné do <c>Station.StationTypeCbID</c>.
 */
const stationTypeSelector = createCodebookSelector('StationType');

export const StationTypeSelector = stationTypeSelector.Selector;
export const StationTypeSelectorField = stationTypeSelector.Field;
